import React from 'react'
import { LoggerService } from '../../application/services/Logger/LoggerService'
import { LoggerServiceConsole } from '../../application/services/Logger/LoggerServiceConsole'

export const LoggerContext = React.createContext<LoggerService>(LoggerServiceConsole)
